export default `query urlResolver ($category: String!) {
  urlResolver (category: $category) {
    id
    redirectCode
    redirectCode
    type
  }
}`
